module.exports = __webpack_public_path__ + "media/sweepstakes_and_promotions/sweepstakes_promotions_header-58ac3917.png";